import { MFRRestrictionsDataItem } from '../list/mfr_restrictions_list_types';

export function mfrRestrictionsListApiToVM(data: object): MFRRestrictionsDataItem[] {
    const items = Array.isArray(data) ? (data as MFRRestrictionsDataItem[]) : [];

    // do this once per API call rather than on every render
    items.forEach(item => {
        item.CeRestrictTypes =
            Array.isArray(item.CeRestrictTypes) && item.CeRestrictTypes.length === 0 ? ['ALL'] : item.CeRestrictTypes;
        item.ExemptStates =
            Array.isArray(item.ExemptStates) && item.ExemptStates.length === 0 ? ['NONE'] : item.ExemptStates;
    });

    return items;
}
